import React from 'react';

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../assets/logo.svg";
import Nav from "react-bootstrap/Nav";

import { useNavigate } from 'react-router-dom';
import './styles.css';

function TopNavbar() {

    let navigate = useNavigate();


    return (
        <div style={{background: "#1F0E28"}} id='top'>
            <Navbar collapseOnSelect expand="md" bg="transparent" variant="dark">
                <Container fluid className="px-lg-5">

                    <Navbar.Brand className="top-nav-logo" onClick={() => { navigate('/') }}>
                        <img
                            alt="Sawti Ilak Microphone Logo"
                            src={Logo}
                            width="25%"
                            height="35"
                            className="d-inline-block nav-logo"
                        />
                        {' '}
                        <p className="d-inline-block fs-4 fw-bold">Sawti Ilak</p>
                    </Navbar.Brand>


                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse>
                    <Nav
                        className='nav-adjust flex-grow-1 justify-content-center navbar-adjustment'
                    >
                        <Nav.Item>
                            <Nav.Link href="/" style={{fontSize: "20px"}}>Home</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link href="/archive" style={{fontSize: "20px"}}>Previous Events</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

export default TopNavbar;
